import {getTicketById, getTickets} from '../../../../../../selectors/tickets'
import {DetailsPageAppProps} from '../../../../../app/interfaces'
import {connect} from '../../../../../runtime-context/context'
import {CustomDatesLabel as Presentation} from './custom-dates-label'
import {CustomDatesLabelOwnProps, CustomDatesLabelRuntimeProps} from './interfaces'

const mapRuntime = ({state}: DetailsPageAppProps, {place}: CustomDatesLabelOwnProps): CustomDatesLabelRuntimeProps => ({
  ticket: getTicketById(getTickets(state), place?.ticket?.id),
})

export const CustomDatesLabel = connect<CustomDatesLabelOwnProps, CustomDatesLabelRuntimeProps>(mapRuntime)(
  Presentation,
)
export * from './interfaces'
